import {BitrixVue} from 'ui.vue3';
import { mapState } from 'ui.vue3.pinia';
import { vplSiteStore } from '../../store/vplstore';

import { closeHeaderCatalog, clearHeaderMenuDropdown } from '../../tools/functions';

export const HeaderFixedPersonalMenu = {
    computed: {
        ...mapState(vplSiteStore, ['menu', 'IS_AUTHORIZED'])
    },
    mounted(){

    },
    methods: {
        personalClick(e){
            if(!this.IS_AUTHORIZED){
                e.preventDefault();
                $('#entrance').modal();
            }
        }
    },
    template: `
        <template v-if="this.menu.personal">
            <a v-for="menuItem in this.menu.personal.ITEMS" :href="menuItem.LINK" class="header__top-actions-link header__top-actions-link--lk">
                {{menuItem.TEXT}}
            </a>
        </template>
    `
}